var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25C19.8513 25 25 19.8513 25 13.5C25 7.14873 19.8513 2 13.5 2C7.14873 2 2 7.14873 2 13.5C2 19.8513 7.14873 25 13.5 25Z",
    fill: "#FF7A59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0112 16.0367C15.1525 16.0367 14.456 15.3479 14.456 14.4979C14.456 13.648 15.1522 12.9589 16.0112 12.9589C16.8701 12.9589 17.5668 13.6478 17.5668 14.4979C17.5668 15.3481 16.8705 16.0367 16.0112 16.0367ZM16.477 11.5351V10.165C16.6592 10.0816 16.8137 9.94787 16.9224 9.77959C17.0312 9.61132 17.0896 9.41548 17.0909 9.21513V9.18346C17.0909 8.60442 16.612 8.13094 16.0273 8.13094H15.9952C15.4112 8.13094 14.9317 8.60464 14.9317 9.18346V9.21513C14.933 9.41547 14.9914 9.61128 15.1002 9.77955C15.2089 9.94781 15.3634 10.0815 15.5455 10.165V11.5351C15.0211 11.6142 14.5265 11.8295 14.1112 12.1593L10.313 9.23557C10.3396 9.13939 10.3539 9.04021 10.3555 8.94043C10.3555 8.28435 9.8189 7.7518 9.15608 7.75C8.49325 7.74821 7.95554 8.27986 7.95487 8.93617C7.95419 9.59248 8.49056 10.1239 9.15338 10.125C9.36099 10.1241 9.56479 10.0692 9.74478 9.96578L13.4818 12.843C13.1456 13.3438 12.97 13.9351 12.9783 14.5382C12.9866 15.1413 13.1785 15.7276 13.5283 16.2189L12.3914 17.3442C12.2568 17.302 12.1148 17.2895 11.975 17.3076C11.8351 17.3256 11.7009 17.3737 11.5815 17.4486C11.4621 17.5235 11.3603 17.6234 11.2832 17.7414C11.2061 17.8594 11.1555 17.9928 11.1349 18.1322C11.1143 18.2717 11.1241 18.4139 11.1638 18.5492C11.2035 18.6845 11.272 18.8096 11.3646 18.9158C11.4573 19.022 11.5719 19.1069 11.7005 19.1646C11.8291 19.2223 11.9687 19.2515 12.1097 19.25C12.6541 19.25 13.0957 18.8129 13.0957 18.2741C13.0948 18.1794 13.0796 18.0853 13.0508 17.9951L14.1738 16.8828C14.7025 17.2836 15.3478 17.5003 16.0112 17.4998C17.687 17.4998 19.0447 16.156 19.0447 14.4979C19.0447 12.9971 17.9302 11.7577 16.4768 11.5351",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.e0f59b8ce6706c7e9b573750763a3f81.svg";
export { ForwardRef as ReactComponent };